import { Helmet } from "react-helmet"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import {
	ContactSection,
	PageLanding,
	ProjectsList,
	SectionsList,
	ServicesSection,
} from "../components"
import { getProjects, getService } from "../redux"
import "../style/Service.scss"

const titles = {
	"aplicatii-mobile": "Dezvoltare Aplicatii Mobile | Aplicatie iOS si Android",
	"magazin-online": "Create Magazin Online | Magazin Online Rapid",
	"aplicatii-web": "Dezvoltare Aplicatii Web | Aplicatie Web Rapida",
	"promovare-online": "Promovare Online | Online Marketing",
	copywriting: "Copywriting",
	"strategie-de-marketing": "Strategie de Marketing",
}

function Service() {
	const serviceId = useLocation().pathname.slice(1)
	const projects = useSelector(state => getProjects(state, serviceId))
	const service = useSelector(state => getService(state, serviceId))

	if (!service) return <div></div>

	const { background, title, description } = service

	return (
		<div className="service">
			<Helmet>
				<title>{titles[serviceId]} - Xposed Agency</title>
				<meta name="description" content={title} />
			</Helmet>

			<PageLanding src={background} title={title} description={description} />

			<ProjectsList
				projects={projects}
				sectionData={service.secondaryDescription}
			/>

			<ServicesSection
				services={service.approaches}
				mainDescription={service.approachesDescription}
			/>

			<ContactSection />

			<SectionsList
				isAspectRatio
				services={service.solutions || []}
				text={service.solutionsText}
				type="solutions"
				noFindMore
			/>
		</div>
	)
}

export default Service
